import React from "react";

import { Query } from '@apollo/client/react/components';
import gql from "graphql-tag";

import { Link } from "react-router-dom";
import { withRouter } from "react-router";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import LoggedInMenu from "./LoggedInMenu";
import OcrProcessLineItemBox from "./OcrProcessLineItemBox";
import ErrorView from "./ErrorView";
import LoadingView from "./LoadingView";

const FETCH_SEARCH_RESULTS = gql`
  query search($query: String!) {
    search(query: $query) {
      processNumber
      token
      abrechner
      behandlungsdatum
      careProvider
      tags
      eigenanteil
      extReceiptNumber
      leistungBeihilfe
      leistungPkvPpv
      notes
      paidOn
      paid
      receiptClass
      receiptDate
      receiptNumber
      receiptSum
      bhStatus
      vuStatus
      status
      tags
    }
  }
`;
interface ISearchResultProps {
  location: any;
  match: any;
  history: any;
}

class SearchResults extends React.Component<ISearchResultProps> {
  extractQuery() {
    const params: any = new URLSearchParams(this.props.location.search);
    const query = params.get("q");

    if (query === undefined || query === "") {
      return null;
    }

    return query;
  }

  render() {
    const query = this.extractQuery();

    return (
      <>
        <LoggedInMenu history={this.props.history} />

        <div className="content-wrapper">
          <Container fluid>
            <Row>
              <Col xs={12} lg={10} className="main">
                <div className="sitecontent">
                  <Container fluid>
                    <Row>
                      <Col xs={12} className="pb-3">
                        <h1 className="underline">
                          <span className="icon-list"></span> Suchergebnisse
                        </h1>
                      </Col>
                      <Col xs={12}>
                        <div className="wrapper-suchergebnisse">
                          {query === null && (
                            <ErrorView error="Invalid query"></ErrorView>
                          )}
                          {query !== null && (
                            <Query
                              query={FETCH_SEARCH_RESULTS}
                              variables={{ query: query }}
                            >
                              {({ loading, error, data }: any) => {
                                if (loading) {
                                  return <LoadingView />;
                                }

                                if (error) {
                                  return <ErrorView error={error} />;
                                }

                                if (data.search.length === 0) {
                                  return (
                                    <>
                                      <h4>
                                        Keine Suchergebnisse für "{query}".
                                      </h4>
                                      {/* TODO: Hinweistext auf Suchformat */}
                                    </>
                                  );
                                }

                                let processes: any = {};

                                for (let receipt of data.search) {
                                  const processNumber: string =
                                    receipt.processNumber;
                                  if (processes[processNumber] === undefined) {
                                    processes[processNumber] = [receipt];
                                  } else {
                                    processes[processNumber].push(receipt);
                                  }
                                }

                                const items = Object.entries(processes).map(
                                  (entry: any, idx: number) => (
                                    <>
                                      <h5>
                                        <Link to={`/vorgang/${entry[0]}`}>
                                          {entry[0]}
                                        </Link>
                                      </h5>
                                      {entry[1].map(
                                        (process: any, idx2: number) => (
                                          <OcrProcessLineItemBox
                                            item={process}
                                            processNumber={
                                              process.processNumber
                                            }
                                            key={`result-${idx}-${idx2}`}
                                          />
                                        )
                                      )}
                                      <hr />
                                    </>
                                  )
                                );

                                return (<>{items}</>);
                              }}
                            </Query>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  }
}

export default withRouter(SearchResults);
